/*
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   selectResidentQuotes
 */

import { createSelector } from '@reduxjs/toolkit'
import type { State } from '@zcode/state-type'
import { compose } from 'redux'
import { MAX_QUOTES_TO_SHOW, RESIDENT_QUOTES_SLICE_NAME } from './constants'

const selectResidentQuotes = (state: State) => state[RESIDENT_QUOTES_SLICE_NAME]

const selectResidentQuotesData = compose((state) => state.data, selectResidentQuotes)

export const selectResidentQuotesGroupId = compose((state) => state.groupId, selectResidentQuotes)

export const selectResidentQuotesQuotes = createSelector(selectResidentQuotesData, (state) =>
  state?.quotes
    ?.filter((quote) => quote.quote !== state.propertySummary)
    .slice(0, MAX_QUOTES_TO_SHOW)
)

export const selectResidentQuotesUrl = compose((state) => state?.url, selectResidentQuotesData)

export const selectResidentQuotesSummaryQuoteParagraph = compose(
  (state) => state?.propertySummary,
  selectResidentQuotesData
)

export const selectResidentQuotesThumbnail = compose(
  (state) => state?.thumbnailQuote,
  selectResidentQuotesData
)

export const selectShouldShowResidentQuotes = (state: State) => {
  const quotes = selectResidentQuotesQuotes(state)
  return (quotes?.length ?? 0) > 1
}
